import type { InventoryVehicle } from '@carvana/merch-contracts';

export type ComposerSearchResultVehicle = {
  bodyStyle: string;
  color: string;
  fuelType?: string;
  make: string;
  mileage: number;
  model: string;
  monthlyPayment?: number;
  mpg: number;
  price?: number;
  tags: Array<string>;
  term?: number;
  trim: string;
  vdpSlug: string;
  vehicleId: number;
  year: number;
};

export default function buildComposerSearchResults(
  vehicles: Array<InventoryVehicle>
): Array<ComposerSearchResultVehicle> {
  return vehicles.map(vehicle => ({
    bodyStyle: vehicle.bodyStyle,
    color: vehicle.color,
    fuelType: vehicle.fuelType,
    make: vehicle.make,
    mileage: vehicle.mileage,
    model: vehicle.model,
    monthlyPayment: vehicle.price?.monthlyPayment,
    mpg: vehicle.milesPerGallon,
    price: vehicle.price?.total,
    tags: vehicle.vehicleTags.map(tag => tag.tagName),
    term: vehicle.price?.term,
    trim: vehicle.trim,
    vdpSlug: vehicle.vdpSlug,
    vehicleId: vehicle.vehicleId,
    year: vehicle.year
  }));
}
